// extracted by mini-css-extract-plugin
export default {"editItemContainer":"styles_editItemContainer__f4AFf","editItemLabel":"styles_editItemLabel__wbT8o"};